// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1N4Yk","loaderOuter":"PageOverlayLoader_loaderOuter__2drcf"};